export default __webpack_public_path__ + "static/media/milestone_grey.12619b2e.svg";